module.exports = __webpack_public_path__ + "static/bat-race-007b914abec38dc0e8779ba951492239.jpg";